export default "__VITE_ASSET__FVcJucu1__"